import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { FileRecordObject, FileRecordError } from '../records/file-record';

@Component({
       selector: 'validation-errors',
    templateUrl: './validation-errors.component.html',
      styleUrls: [ './validation-errors.component.css' ]
})
export class ValidationErrorsComponent {

    @ViewChild(ModalComponent)
    private modalComponent: ModalComponent;

    public modalTitle: string;
    public modalErrors: ErrorDisplay[];

    public open(fileRecord: FileRecordObject): any {
        let noun = fileRecord.errors.length == 1 ? "error" : "errors";
        this.modalTitle = fileRecord.fileName +
            " (" + fileRecord.errors.length + " " + noun + " found)";
        this.modalErrors = fileRecord.errors.map((fileRecordError) => {
            return {
                location: this.locationString(fileRecordError),
                description: fileRecordError.errorMessage
            };
        });
        this.modalComponent.open();
    }

    private locationString(fileRecordError: FileRecordError): string {
        if(fileRecordError.lineNumber != null) {
            return "Line " + fileRecordError.lineNumber;
        }
        if(fileRecordError.sampleId != null) {
            return "Sample ID " + fileRecordError.sampleId;
        }
        return "";
    }
}

class ErrorDisplay {
    location: string;
    description: string;
}
